import { AbstractItemSelector } from './item-selector';
import { ItemCardSelectionInfoKind, QuantityItemCardSelectionInfo, SafelySelectableMenuItem } from '@/models';

export type SelectQuantityItemArgs = number;

export class QuantityItemSelector extends AbstractItemSelector<SelectQuantityItemArgs> {
  selectItem(item: SafelySelectableMenuItem<QuantityItemCardSelectionInfo>, args: SelectQuantityItemArgs) {
    item.selectionInfo.quantity = args;

    return true;
  }

  deselectItem(item: SafelySelectableMenuItem<QuantityItemCardSelectionInfo>) {
    item.selectionInfo.quantity = 0;
  }

  getSelectionKind() {
    return ItemCardSelectionInfoKind.Quantity;
  }

  isItemSelected(item: SafelySelectableMenuItem<QuantityItemCardSelectionInfo>): boolean {
    return item.selectionInfo.quantity > 0;
  }

  isDeselecting(item: SafelySelectableMenuItem<QuantityItemCardSelectionInfo>, args: SelectQuantityItemArgs) {
    return args == 0;
  }

  getQuantityAfterSelection(item: SafelySelectableMenuItem<QuantityItemCardSelectionInfo>, args: SelectQuantityItemArgs) {
    return args;
  }

  getItemQuantity(item: SafelySelectableMenuItem<QuantityItemCardSelectionInfo>) {
    return item.selectionInfo.quantity;
  }

  getEffectiveItemQuantity(item: SafelySelectableMenuItem<QuantityItemCardSelectionInfo>) {
    return item.selectionInfo.quantity;
  }

  getMaxQuantity(item: SafelySelectableMenuItem<QuantityItemCardSelectionInfo>) {
    return item.selectionInfo.maxQuantity;
  }

  copySelectionTo(target: SafelySelectableMenuItem<QuantityItemCardSelectionInfo>, src: SafelySelectableMenuItem<QuantityItemCardSelectionInfo>) {
    target.selectionInfo.quantity = src.selectionInfo.quantity;

    return true;
  }
}
